import React from "react";
import api, { formatPrice } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";

export default function MobileStickyCTA({ property }) {
  const { settings, feature } = useSettings();
  const number = (settings?.whatsapp_number || "").replace(/[^0-9]/g, "");
  if (!feature("whatsapp_enquiry") || !number || !property) return null;

  const location = [property.area_name, property.city].filter(Boolean).join(", ");
  const text = `Hi, I'm interested in this property:\n*${property.title}*\nLocation: ${location}${property.pincode ? ` - ${property.pincode}` : ""}\nProperty ID: ${property.id}\n\nPlease share more details.`;

  const onClick = () => {
    window.open(`https://wa.me/${number}?text=${encodeURIComponent(text)}`, "_blank");
    api.post("/whatsapp-enquiries", { property_id: property.id }).catch((err) => console.debug("wa enquiry log failed", err));
  };

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-card/95 backdrop-blur border-t border-brand-line px-4 py-3 flex items-center gap-3 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
      data-testid="mobile-sticky-cta"
    >
      <div className="min-w-0">
        <div className="text-[11px] text-brand-muted leading-none">Price</div>
        <div className="font-heading font-bold text-brand-emerald text-lg leading-tight truncate">{formatPrice(property.price, property.price_unit)}</div>
      </div>
      <button
        onClick={onClick}
        data-testid="mobile-sticky-wa"
        className="ml-auto flex items-center justify-center gap-2 rounded-full bg-brand-lease hover:bg-brand-lease/90 text-white font-medium px-5 py-2.5 shrink-0 transition-colors"
      >
        <MessageCircle className="w-4 h-4" /> Contact on WhatsApp
      </button>
    </div>
  );
}
